import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../bookingConfirm/BookingConfirm.css'

const BookingConfirm = () => {
    const [selectedTermsConditionsType, setSelectedTermsConditionsType] = useState("TermsConditions");
    const [selectedCancellationType, setSelectedCancellationType] = useState("Cancellation");
    const [selectePayment, setSelectedPayment] = useState("Payment");

  return (
    <div className='inner-booking-right-box'>
    <div className='booking-right-top'>
        <h2>Terms and Conditions</h2>
        <div className='terms-box'>
            <ul className='radio-box-checked d-flex align-items-center'>
                <li>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="TermsConditionsType" id="TermsConditions" value="TermsConditions" checked={selectedTermsConditionsType==="TermsConditions" } onChange={()=> setSelectedTermsConditionsType("TermsConditions")} />
                        <label className="form-check-label" htmlFor="TermsConditions">I have read and understood the Terms and Conditions.</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div className='booking-right-top mb-4'>
        <h2>Cancellation Policy</h2>
        <div className='terms-box'>
            <ul className='radio-box-checked d-flex align-items-center'>
                <li>
                    <div className="form-check">
                        <input className="form-check-input" type="radio" name="CancellationType" id="Cancellation" value="Cancellation" checked={selectedCancellationType==="Cancellation" } onChange={()=> setSelectedCancellationType("Cancellation")} />
                        <label className="form-check-label" htmlFor="Cancellation">I have read and understood the Cancellation Policy. </label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div className='booking-bootm-box'>
        <div className='estimated-box'>
            <h2>Estimated Cost</h2>
            <ul className='table-layout-box'>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Service</span>
                    <span>$45.00</span>
                </li>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Add on</span>
                    <span>$45.00</span>
                </li>
                <li className='d-flex flex-wrap justify-content-between'>
                    <span>Travel fee</span>
                    <span>$3.50</span>
                </li>
            </ul>
            <ul className='total-out-put d-flex flex-wrap align-items-center justify-content-between'>
                <li>Total</li>
                <li className='text-color-pink'>$93.50</li>
            </ul>

            <div className='payment-method-service-sec'>
                <h6>Payment Method</h6>
                <div className='payment-method d-flex align-items-center justify-content-between gap-2'>
                    <div className='left-icons d-flex align-items-center gap-2'>
                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_182_5265)"><rect x="1" width="32" height="32" rx="10" fill="white"/><rect x="1.5" y="0.5" width="31" height="31" rx="9.5" stroke="#EEE6F1"/><path d="M19.9732 21.2784H14.0234V10.7242H19.9732V21.2784Z" fill="#FF5F00"/><path d="M14.4048 16C14.4048 13.859 15.4204 11.9519 17.0019 10.7229C15.8454 9.82413 14.3858 9.28771 12.7995 9.28771C9.04416 9.28771 6 12.2929 6 16C6 19.7071 9.04416 22.7122 12.7995 22.7122C14.3858 22.7122 15.8454 22.1758 17.0019 21.2771C15.4204 20.0481 14.4048 18.141 14.4048 16Z" fill="#EB001B"/><path d="M28.0004 16C28.0004 19.7071 24.9563 22.7122 21.2009 22.7122C19.6146 22.7122 18.155 22.1758 16.998 21.2771C18.58 20.0481 19.5956 18.141 19.5956 16C19.5956 13.859 18.58 11.9519 16.998 10.7229C18.155 9.82413 19.6146 9.28771 21.2009 9.28771C24.9563 9.28771 28.0004 12.2929 28.0004 16Z" fill="#F79E1B"/></g><defs><filter id="filter0_d_182_5265" x="0" y="0" width="34" height="34" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="1"/><feGaussianBlur stdDeviation="0.5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_182_5265"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_182_5265" result="shape"/></filter></defs></svg>
                        <span>**** **** **** 1234</span>
                    </div>
                    <div className='right-btn-box d-flex align-items-center gap-2'>
                        <Link to="" className='btn btn-primary'>Default</Link>
                        <span>
                            <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="2" cy="2" r="2" fill="#301E39"/><circle cx="2" cy="8" r="2" fill="#301E39"/><circle cx="2" cy="14" r="2" fill="#301E39"/></svg>
                        </span>
                    </div>
                </div>
                <Link to="" className='btn btnadd-payment  d-flex align-items-center gap-2'> 
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9286 11.0714H11.5714V16.4286C11.5714 17.0179 11.0893 17.5 10.5 17.5C9.91071 17.5 9.42857 17.0179 9.42857 16.4286V11.0714H4.07143C3.48214 11.0714 3 10.5893 3 10C3 9.41071 3.48214 8.92857 4.07143 8.92857H9.42857V3.57143C9.42857 2.98214 9.91071 2.5 10.5 2.5C11.0893 2.5 11.5714 2.98214 11.5714 3.57143V8.92857H16.9286C17.5179 8.92857 18 9.41071 18 10C18 10.5893 17.5179 11.0714 16.9286 11.0714Z" fill="#FD59D9"/></svg>
                    <span>Add Payment Method</span>
                </Link>
                <ul className='select-payment-option'>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="Payment" id="Payment" value="Payment" checked={selectePayment==="Payment" } onChange={()=> setSelectedPayment("Payment")} />
                            <label className="form-check-label" htmlFor="Payment">Pay in person</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="Payment1" id="Payment1" value="Payment1" checked={selectePayment==="Payment1" } onChange={()=> setSelectedPayment("Payment1")} />
                            <label className="form-check-label" htmlFor="Payment1">Apple Pay</label>
                        </div>
                    </li>
                    <li>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="Payment2" id="Payment2" value="Payment2" checked={selectePayment==="Payment2" } onChange={()=> setSelectedPayment("Payment2")} />
                            <label className="form-check-label" htmlFor="Payment">Google Pay</label>
                        </div>
                    </li>
                </ul>
            </div>

            <Link rel='stylesheet' to='/add-service' className='btn btn-border btn-pink d-flex justify-content-center'>Confirm Request</Link>
        </div>
    </div>
</div>
  )
}

export default BookingConfirm